<nz-picker
  [isRange]="isRange"
  [value]="nzValue"
  (valueChange)="onValueChange($event)"
  [open]="nzOpen"
  [disabled]="nzDisabled"
  [format]="nzFormat"
  [allowClear]="nzAllowClear"
  [autoFocus]="nzAutoFocus"
  [className]="nzClassName"
  [placeholder]="nzPlaceHolder"
  [size]="nzSize"
  [style]="pickerStyle"
  [noAnimation]="noAnimation?.nzNoAnimation"
  (openChange)="onOpenChange($event)"
>
  <date-range-popup *ngIf="realOpenState"
    [isRange]="isRange"
    [showWeek]="showWeek"
    [panelMode]="nzMode"
    (panelModeChange)="nzOnPanelChange.emit($event)"
    [value]="nzValue"
    (valueChange)="onValueChange($event)"
    (calendarChange)="onCalendarChange($event)"
    [locale]="nzLocale?.lang"
    [showToday]="realShowToday"
    [showTime]="nzShowTime"
    [format]="nzFormat"
    [dateRender]="nzDateRender"
    [disabledDate]="nzDisabledDate"
    [disabledTime]="nzDisabledTime"
    [placeholder]="nzPlaceHolder"
    [dropdownClassName]="nzDropdownClassName"
    [popupStyle]="nzPopupStyle"
    [extraFooter]="extraFooter"
    [ranges]="nzRanges"
    (resultOk)="onResultOk()"
    (closePicker)="closeOverlay()"
  ></date-range-popup>
</nz-picker>